import React from "react";

import {Grid} from "@mui/material";
import {FormInput} from "../../../../../components/form/form_inputs/form_input";
import {FormContent} from "../../../../../components/form/form_inputs/form_buttons";
import {OrganizationUnitMember, OrganizationUnitMemberRestControllerApiFactory, Person} from "arteco-api-client-ts";
import {useForm, UseFormProps,} from "../../../../../components/form/form_model";
import {useApiManager} from "../../../../../components/utils/api";
import {useParams} from "react-router-dom";
import {usePerson} from "../index";
import {parsePathId} from "../../../../../components/form/form_utils";
import {types} from "../../../../../components/form/types";
import FormAutocomplete from "../../../../../components/form/form_inputs/form_autocomplete";

export const UnitMemberEditPage = () => {
	const params = useParams();
	const personId = parsePathId(params, "personId");
	const manager = useApiManager();
	const ctrl = manager.factory(OrganizationUnitMemberRestControllerApiFactory);
	const [person, setPerson] = usePerson(personId);

	const form = useForm({
		fetcher: (id) => ctrl.getOrganizationUnitMember(id),
		updater: (bean) => ctrl.saveOrganizationUnitMember(bean),
		remover: (id) => ctrl.deleteOrDismissOrganizationUnitMember(id),
		factory: () => {
			return {
				person: {id: personId} as Person,
			} as OrganizationUnitMember;
		},

	} as UseFormProps<OrganizationUnitMember>);

	return (
		<>
			<FormContent
				form={form}
				title={
					"Ficha de Unidad para [" +
					(person ? person.surnames + ", " + person.name : "") +
					"]"
				}>


				<Grid container spacing={3}>
					<Grid item sm={3}>
						<FormInput field={"startDate"} type={"date"} label={"Fecha Inicio"}/>
					</Grid>
					<Grid item sm={3}>
						<FormAutocomplete field={"person"} label={"Persona"} type={types.people}/>
					</Grid>
					<Grid item sm={3}>
						<FormAutocomplete field={"unit"} label={"Unidad Organizativa"} type={types.organizationUnits}/>
					</Grid>
				</Grid>

			</FormContent>
		</>
	);
};